import { memo, useState } from 'react'
import { MonitoringEnabledInput } from '../../inputs/monitoring-input'

export const MonitoringEnabledWrapperMock = ({
  enabled,
  activeSubscription,
  domain,
}: {
  enabled?: boolean
  url?: string
  activeSubscription?: boolean
  domain?: string
}) => {
  const [monitoringEnabled, setMonitoring] = useState<boolean>(!!enabled)

  const onMonitoringEvent = async () => {
    setMonitoring(!monitoringEnabled)
  }

  return (
    <MonitoringEnabledInput
      checked={monitoringEnabled}
      activeSubscription={activeSubscription}
      onChange={onMonitoringEvent}
      domain={domain}
    />
  )
}

export const MonitoringEnabledBoxMock = memo(MonitoringEnabledWrapperMock)
